import { useEffect } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { img } from "@/lib/api";

export const Lightbox = ({ images, index, onChange, onClose }) => {
  const prev = () => onChange((index - 1 + images.length) % images.length);
  const next = () => onChange((index + 1) % images.length);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onChange((index - 1 + images.length) % images.length);
      if (e.key === "ArrowRight") onChange((index + 1) % images.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, images.length, onChange, onClose]);
  if (index === null || index === undefined) return null;
  const cur = images[index];
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-ink/95 p-4" data-testid="lightbox">
      <button onClick={onClose} className="absolute right-5 top-5 text-white" aria-label="Close" data-testid="lightbox-close"><X className="h-8 w-8" /></button>
      <button onClick={prev} className="absolute left-3 rounded-full bg-white/10 p-3 text-white hover:bg-white/20" aria-label="Previous" data-testid="lightbox-prev"><ChevronLeft /></button>
      <figure className="max-h-full max-w-6xl">
        <img src={img(cur.src)} alt={cur.alt} className="max-h-[82vh] w-auto rounded-lg object-contain" />
        <figcaption className="mt-3 text-center text-sm font-semibold text-white/80">{cur.alt} · {index + 1} / {images.length}</figcaption>
      </figure>
      <button onClick={next} className="absolute right-3 rounded-full bg-white/10 p-3 text-white hover:bg-white/20" aria-label="Next" data-testid="lightbox-next"><ChevronRight /></button>
    </div>
  );
};
